export const IsValidEmail = email => {
  if (email === undefined) {
    return false
  }
  if (!email || email.indexOf("@") === -1) {
    return { isValid: false, message: "Enter valid email Id." }; // Error if '@' is not present
  }
  if (!email || email.indexOf(".com") === -1) {
    return { isValid: false, message: "Email must contain .com" }; // Error if '.com' is not present
  }

  return true
}
